export const styles = {
  title: {
    mb: 4,
  },
  table: {
    mb: 4,
  },
};
